module.exports = __webpack_public_path__ + "media/images/partner/media/ksta-0a5da093ace0b1654e196d8e997e1863.png";